export default {
  menu: 'Payments',
  title: 'Payments',

  general: {
    bankTypes: {
      pos: 'POS',
      card: 'card to card',
      sheba: 'IBAN'
    },

    types: {
      cash: 'fund',
      bank: 'bank',
      user: 'User',
      storeroom: 'store',
      paymentGateway: 'payment gateway'
    },

    paymentTypes: {
      customer: 'Payment to customer',
      supplier: 'Payment to supplier',
      account: 'Payment to account'
    },

    labels: {
      all: 'All',
      type: 'Type',
      account: 'Account',
      paymentType: 'payment type',
      date: 'date of payment',
      user: 'Pay to',
      source: 'Payment from',
      price: 'Amount',
      hasWage: 'Fee',
      wage: 'Fee deduction',
      totalPriceWithWage: 'Total Price',
      description: 'Description',
      transactionsReferenceId: 'Tracking number',
      maxPayment: 'Maximum payable',
      dynamicBalance: 'credit {balance}',
      bankBalance: 'Bank balance',
      cashBoxBalance: 'Funds'
    },

    placeholder: {
      date: 'Automatic'
    },

    table: {
      header: {
        restore: 'Restore',
        delete: 'Delete',
        price: 'Amount',
        destination: 'Recipient',
        source: 'Payer',
        description: 'Documents',
        creator: 'Creator',
        date: 'Date',
        docNumber: 'Document number',
        row: 'Row'
      }
    },

    notifications: {
      invalidUser: 'Person not selected',
      invalidAccount: 'Account not selected',
      invalidPrice: 'Amount is not valid',
      invalidPaymentFrom: 'Payment source not selected',
      invalidPaymentType: 'Payment type not specified',
      invalidDescription: 'Payment Description has not been entered',
      price: 'The entered amount is more than the maximum amount that can be paid!',
      lowBalance: 'The balance of the bank or fund is not enough!',
      lowBalanceDynamicDate: 'The balance of the bank or fund in selected date is not enough!',
      incorrect_reference_id: 'reference id is not correct',

      insert: {
        success: 'Payment created successfully',
        error: 'Creating a payment with an error'
      },
      delete: {
        success: 'Payment information successfully deleted',
        error: 'Deleting payment information failed'
      },
      restore: {
        success: 'Payment information successfully restored',
        error: 'Restore the payment information was accompanied by an error'
      },
      print: {
        success: 'Your request has been sent, please wait',
        error: 'The print request has error'
      }
    },

    confirmations: {
      emptyTreasury: {
        title: 'No bank or cash connected',
        body: 'To create {name}, you need to connect a bank or cash. Please create one first.'
      },
      delete: {
        title: 'Confirm Delete payment',
        body: 'Are you sure you want to delete this payment completely?'
      }
    },

    validators: {
      dateHelp: 'The entry must be entered as {date}.',
      date: 'The payment date is not entered correctly!',
      future: 'It is not possible to register a payment for the future'
    }
  },

  insert: {
    title: 'New Payment',

    suggests: {
      description: 'Received from {user} for {subject}'
    }
  },

  list: {
    title: 'Payments'
  },

  trash: {
    title: 'Removed Payments List'
  },

  document: {
    title: 'Payment',
    dynamicTitle: 'Payment number {docNumber}',

    labels: {
      sources: 'Payer / payers',
      destinations: 'Recipient / recipients',
      details: 'Other information',
      creator: 'creator',
      date: 'Registration date',
      description: 'Description'
    }
  },

  logs: {
    title: 'Payment logs'
  }
}
